import type { HeroKey } from '@wl/theme';
import { IMG } from '../../imgPrefix';
import type { ContentPageLink } from './content';
import { ALL_VERTICALS, type Vertical } from './verticals';

/**
 * What client components need to render the tenant's chrome. Plain data: it crosses the
 * server → client boundary through TenantBrandProvider.
 */
export interface TenantBrand {
  tenantKey: string;
  name: string;
  isDefault: boolean;
  /** Logo URL; undefined → render `name` as a wordmark. */
  logo?: string;
  favicon: string;
  ogImage?: string;
  /** The tenant's own hero images — resolve through `heroFor` (./hero), never directly. */
  heroes: Partial<Record<HeroKey, string>>;
  verticals: Vertical[];
  /** BCP 47 language for <html lang>. */
  lang: string;
  /** Tenant.SupportEmail; undefined for BookItPlease, whose copy names its own addresses. */
  supportEmail?: string;
  /** `https://<request host>`, for canonical URLs. */
  origin?: string;
  /** The tenant's published content pages (`/p/<slug>`), for the footer. */
  pages: ContentPageLink[];
  /** BCP 47 locale for DISPLAY formatting (dates, numbers). Never for wire formats. */
  locale: string;
  /** Default display currency (ISO 4217) when the visitor has not chosen one. */
  currency: string;
  /** Currencies the visitor may pick; empty = every currency the platform supports. */
  currencies: string[];
}

/** BookItPlease's own chrome — the default tenant, and single-tenant mode (no tenant service). */
export const PLATFORM_BRAND: TenantBrand = {
  tenantKey: 'bookitplease',
  name: 'BookItPlease',
  isDefault: true,
  logo: `${IMG}/image/purple-new_logo.png`,
  favicon: `${IMG}/image/fab-icon11.svg`,
  heroes: {},
  pages: [],
  locale: 'en-GB',
  currency: 'GBP',
  currencies: [],
  verticals: [...ALL_VERTICALS],
  lang: 'en',
};

